export default function Image (pButton)
{
  this.preInitInsertImageButton = () =>
  {
    if (pButton.pGroup.pToolbar.tWindow.BonaDialog === undefined || !pButton.pGroup.pToolbar.tWindow.BonaDialog)
    {
      setTimeout(this.preInitInsertImageButton, 100);
      return;
    }

    pButton.pAttribute.model.id = pButton.pAttribute.id + '_Dialog' + BEditor.utils.getUniqueIdentifier();
    pButton.pAttribute.model.parentComponent = pButton.pThis;

    if (BEditor.Dialogs['Resource'])
    {
      pButton.pAttribute.Dialog = BEditor.Dialogs['Resource'].dialog;
    }
    else
    {
      pButton.pAttribute.Dialog = new BEditor.UI.InsertResourceDialog(pButton.pAttribute.model);
      BEditor.Dialogs['Resource'] = { 'id': pButton.pAttribute.id + '_Dialog', 'codeEditor': pButton.pAttribute.codeEditor, 'dialog': pButton.pAttribute.Dialog};
    }

    pButton.pThis.RenderComplete.fireHandlers();
  };
}